import { Typography } from "antd";
import { getThresholdValue } from "./utils";

const { Title } = Typography;

const renderTotal = (thresholdType, defaultBillingThreshold, total) => (
  <span className={total >= defaultBillingThreshold ? "rag-green" : "rag-red"}>
    {getThresholdValue(thresholdType, total)}
  </span>
);

export const ApprovalTotal = ({
  thresholdType,
  defaultBillingThreshold,
  exceptions,
  total,
  exceptionsTotal,
  displayClientName = false,
  renderExceptions = (e) => e,
}) => {
  const exceptionsToRender = exceptions.map((a) => (
    <div key={a.id}>
      <Typography.Text>
        {displayClientName && `${a.client.name}: `}
        {renderTotal(
          a?.thresholdType,
          a?.defaultBillingThreshold,
          exceptionsTotal?.[a.id] || 0,
        )}
      </Typography.Text>
    </div>
  ));

  return (
    <div style={{ textAlign: "right" }}>
      <div
        style={{
          height: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Title style={{ margin: 0 }} level={5}>
          Total: {renderTotal(thresholdType, defaultBillingThreshold, total)}
        </Title>
      </div>
      {renderExceptions(exceptionsToRender)}
    </div>
  );
};
